<script>
import {generateUUID, percentage_format, numberWithCommas} from "@/utils.js";
import moment from "moment";
import baselinesData from "@/data/baselinesData.json";
export default {
  name: "local-market",
  props: [
    "pos_metrics",
    "region_metrics",
    "total_sales_yoy_data",
    "marketing_recommendations",
    "form",
    "campaign_start_total_sales",
    "campaign_end_total_sales",
    "yoyCategoryView",
    "isNetworkData"
  ],
  data() {
    return {
      options: {},
      series: [],
      result: [],
      temp_dates: [],
      dates: [],
      hasData: false,
      baselines: baselinesData,
      campaign_start: "",
      campaign_end: "",
      formkpi: {
        selectedKPIMetric : 'sales',
        selectedYearOver: this.form.selectedYearOver,
      },
      overYearOption: [
        { text: "Year over Year", value: 1},
        { text: "Year over 2 Years", value: 2}
      ],
      KPIMetricOptions : [
        { text: "Sales", value: 'sales'},
        { text: "Traffic", value: 'traffic'},
        { text: "Average Check", value: 'average_check'},
        { text: "Frequency", value: 'frequency'},
        { text: "Recency", value: 'recency'},
      ],
      isSearch: false,
    };
  },
  computed: {
    chartId() {
      return `chart_${generateUUID()}`;
    },
    hasMarketingRecommendations() {
      return this.marketing_recommendations.length > 0;
    },
    averageCheckRecommendation() {
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Average Check"
      );
    },
    averageCheckRecommendationTestValue() {
      return (
          Math.round(this.averageCheckRecommendation.metric_test_value * 100) /
          100
      );
    },
    averageCheckRecommendationDiff() {
      return (
          Math.round(
              (this.averageCheckRecommendation.metric_test_value -
                  this.averageCheckRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    averageCheckRecommendationGrowth() {
      if (this.averageCheckRecommendation.metric_base_value === 0) {
        return this.averageCheckRecommendationDiff;
      }
      return (
          Math.round(
              (this.averageCheckRecommendationDiff /
                  this.averageCheckRecommendation.metric_base_value) *
              100 *
              100
          ) / 100
      );
    },
    averageCheckRecommendationGrowthIncreased() {
      return this.averageCheckRecommendationGrowth > 0;
    },

    increaseInSalesRecommendation() {
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Increase in Sales"
      );
    },
    increaseInSalesRecommendationTestValue() {
      try {
        if (!this.increaseInSalesRecommendation) {
          return 0;
        }
        return (
            Math.round(
                this.increaseInSalesRecommendation.metric_test_value * 100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    formattedIncreaseInSalesRecommendationTestValue() {
      return this.increaseInSalesRecommendationTestValue
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    increaseInSalesRecommendationDiff() {
      return (
          Math.round(
              (this.increaseInSalesRecommendation.metric_test_value -
                  this.increaseInSalesRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    increaseInSalesRecommendationDiffAbs() {
      return Math.abs(this.increaseInSalesRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formattedIncreaseInSalesRecommendationDiff() {
      return Math.abs(this.increaseInSalesRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    increaseInSalesRecommendationGrowth() {
      try {
        if (this.increaseInSalesRecommendation.metric_base_value === 0) {
          return this.newCustomersRecommendationDiff;
        }
        return (
            Math.round(
                (this.increaseInSalesRecommendationDiff /
                    this.increaseInSalesRecommendation.metric_base_value) *
                100 *
                100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    increaseInSalesRecommendationIncreased() {
      return this.increaseInSalesRecommendationGrowth > 0;
    },

    newCustomersRecommendation() {
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "mc_traffic_local_market"
      );
    },
    newCustomersRecommendationTestValue() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      return numberWithCommas(
          Math.round(this.newCustomersRecommendation.metric_test_value * 100) /
          100
      );
    },
    newCustomersRecommendationDiff() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      return (
          Math.round(
              (this.newCustomersRecommendation.metric_test_value -
                  this.newCustomersRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    formattedNewCustomersRecommendationDiff() {
      return Math.round(Math.abs(this.newCustomersRecommendationDiff))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationDiffAbs() {
      return Math.abs(this.newCustomersRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationGrowth() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      try {
        if (this.newCustomersRecommendation.metric_base_value === 0) {
          return this.newCustomersRecommendationDiff;
        }
        return (
            Math.round(
                (this.newCustomersRecommendationDiff /
                    this.newCustomersRecommendation.metric_base_value) *
                100 *
                100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    formattedNewCustomersRecommendationGrowth() {
      return Math.abs(this.newCustomersRecommendationGrowth)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationIncreased() {
      return this.newCustomersRecommendationGrowth > 0;
    },
    trafficRecommendation() {
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Traffic"
      );
    },
    trafficRecommendationTestValue() {
      if (
          !this.trafficRecommendation ||
          typeof this.trafficRecommendation === "undefined"
      ) {
        return 0;
      }
      return numberWithCommas(
          Math.round(this.trafficRecommendation.metric_test_value * 100) / 100
      );
    },
    trafficRecommendationDiff() {
      if (
          !this.trafficRecommendation ||
          typeof this.trafficRecommendation === "undefined"
      ) {
        return 0;
      }
      return (
          Math.round(
              (this.trafficRecommendation.metric_test_value -
                  this.trafficRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    trafficRecommendationDiffAbs() {
      return Math.abs(this.trafficRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    trafficRecommendationGrowth() {
      try {
        if (this.trafficRecommendation.metric_base_value === 0) {
          return this.trafficRecommendationDiff;
        }
        return (
            Math.round(
                (this.trafficRecommendationDiff /
                    this.trafficRecommendation.metric_base_value) *
                100 *
                100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    trafficRecommendationIncreased() {
      return this.trafficRecommendationGrowth > 0;
    },
    frequencyRecommendation() {
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "mc_frequency_compset" ||
              recommendation.test_name === "Increase in Frequency"
      );
    },
    hasFrequencyRecommendation() {
      return !!this.frequencyRecommendation;
    },
    frequencyRecommendationTestValue() {
      try {
        if (!this.frequencyRecommendation) {
          return 0;
        }
        return (
            Math.round(this.frequencyRecommendation.metric_test_value * 100) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    frequencyRecommendationDiff() {
      if (!this.frequencyRecommendation) {
        return 0;
      }
      return (
          Math.round(
              (this.frequencyRecommendation.metric_test_value -
                  this.frequencyRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    frequencyRecommendationGrowth() {
      if (!this.frequencyRecommendation) {
        return 0;
      }
      if (this.frequencyRecommendation.metric_base_value === 0) {
        return this.frequencyRecommendationDiff;
      }
      return (
          Math.round(
              (this.frequencyRecommendationDiff /
                  this.frequencyRecommendation.metric_base_value) *
              100 *
              100
          ) / 100
      );
    },
    frequencyRecommendationIncreased() {
      return this.frequencyRecommendationGrowth > 0;
    },
    recencyRecommendation() {
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "mc_recency_compset" ||
              recommendation.test_name === "Decrease in Recency"
      );
    },
    hasRecencyRecommendation() {
      return !!this.recencyRecommendation;
    },
    recencyRecommendationTestValue() {
      return (
          Math.round(this.recencyRecommendation.metric_test_value * 100) / 100
      );
    },
    recencyRecommendationDiff() {
      return (
          Math.round(
              (this.recencyRecommendation.metric_test_value -
                  this.recencyRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    recencyRecommendationGrowth() {
      if (!this.recencyRecommendation) {
        return 0;
      }
      if (this.recencyRecommendation.metric_base_value === 0) {
        return this.recencyRecommendationDiff;
      }
      return (
          Math.round(
              (this.recencyRecommendationDiff /
                  this.recencyRecommendation.metric_base_value) *
              100 *
              100
          ) / 100
      );
    },
    recencyRecommendationIncreased() {
      return this.recencyRecommendationGrowth > 0;
    }
  },
  watch: {
    isNetworkData() {
      this.onSearch();
    }
  },
  mounted() {
    // Merge result
    this.result = [];    
    let result = [...this.pos_metrics, ...this.region_metrics];    
    this.result = result;
    let dates = this.result.map(item => item.date);    
    // Filter dates
    dates = dates.filter((v, i, a) => a.indexOf(v) === i);    
    let campaign_start = moment(this.form.campaign.date_start).format(
        "MMM-DD-YYYY"
    );
    let campaign_end = moment(this.form.campaign.date_ended).format(
        "MMM-DD-YYYY"
    );
    if (dates.indexOf(campaign_start) === -1) {
      dates.push(campaign_start.toString());
    }
    if (dates.indexOf(campaign_end) === -1) {
      dates.push(campaign_end.toString());
    }
    this.campaign_start = campaign_start.toString();
    this.campaign_end = campaign_end.toString();
    dates = dates.sort();    
    this.temp_dates = dates;
    this.filterTotalSalesData();
    setTimeout(() => {
      this.onSearch();
    }, 2000);
  },
  methods: {
    filterTotalSalesData() {
      let dates = this.total_sales_yoy_data.map(item => item.date);
      // Filter dates
      dates = dates.filter((v, i, a) => a.indexOf(v) === i);
      for (let i = 0; i < dates.length; i++) {
        let date = dates[i];
        if (this.temp_dates.indexOf(date) === -1) {
          this.temp_dates.push(date);
        }
      }
      let data = [];
      let temp_dates = this.temp_dates.sort();
      for (let i = 0; i < temp_dates.length; i++) {
        let date = temp_dates[i];
        data.push(moment(date).format("YYYY-MM-DD"));
      }
      this.dates = data;
    },
    onSearch() {
      let current_option = "Sales";
      //let current_option = "Traffic";
      let series = [];
      if (this.result && this.result.length > 0) {
        for (let i = 0; i < this.baselines.length; i++) {
          let baseline = this.baselines[i];
          series.push({
            name: baseline.text.concat(" ",current_option),
            data: this.getData(baseline)
          });
        }
      }

     
      if(this.isNetworkData){
        this.series = series;
        this.setChartOptions();
      } else {
        this.setTotalSalesSeries(series); 
      }
    },
    setTotalSalesSeries(series) {
      this.series = [];
      let temp_series = series;
      let data = [];
      for (let i = 0; i < this.dates.length; i++) {
        let d = this.dates[i];
        let total = 0;
        let filter_results = this.total_sales_yoy_data.filter(
            obj => obj.date == d
        );
        for (let j = 0; j < filter_results.length; j++) {
          let item = filter_results[j];
          total = total + (item.value ? parseFloat(item.value) : 0);
        }
        // data.push(total);
        if (d == this.campaign_start) {
          let campaign_start_value =
              this.campaign_start_total_sales &&
              this.campaign_start_total_sales.length == 1 &&
              this.campaign_start_total_sales[0].value
                  ? parseFloat(this.campaign_start_total_sales[0].value)
                  : 0;
          total = total + campaign_start_value;
        }

        if (d == this.campaign_end) {
          let campaign_end_value =
              this.campaign_end_total_sales &&
              this.campaign_end_total_sales.length == 1 &&
              this.campaign_end_total_sales[0].value
                  ? parseFloat(this.campaign_end_total_sales[0].value)
                  : 0;
          total = total + campaign_end_value;
        }

        total = (filter_results && filter_results.length ? total/filter_results.length : 0);

        data.push({
          x: d,
          y: total
        });
      }
      temp_series.push({
        name: "Total Sales",        
        data: data
      });
      this.series = temp_series;
      this.setChartOptions();
      setTimeout(() => {
        this.hasData = true;
      }, 1000);
    },
    getData(baseline) {
      let data = [];
      
      for (let x = 0; x < this.dates.length; x++) {
        let total_sales = 0;
        let d = this.dates[x];
        let filter_results = this.result.filter(
            obj => obj.baseline === baseline.value && obj.date === d
        );
        let sales = 0;
        if (filter_results && filter_results.length) {
          sales = filter_results
              .map(item =>
                  item.sales_yoy_avg !== "NaN" ? parseFloat(item.sales_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        total_sales = total_sales + (sales*100);
        data.push({
          x: d,
          y: total_sales
        });
      }
      return data;
    },
    
    handleYearChanges(){
      console.log("Current year value:",this.formkpi.selectedYearOver.value);
      
      // this.total_sales_yoy_data = ['Change props tes'];
      // console.log("Props changed",this.total_sales_yoy_data)

      this.$emit('overYearOptionSelected', this.formkpi.selectedYearOver.value);
      
      //call search here if logic needs to be changed
      // this.onSearch(this.formkpi.selectedYearOver.value);
      
    },
    handleKPIMetricChanges(){
      console.log("KPI Metric changed",this.formkpi.selectedKPIMetric.value);
      
      let current_selected_kpi_value = this.formkpi.selectedKPIMetric.value;

      this.$emit('kpi', current_selected_kpi_value);
      
      let baseline_append_metric = this.KPIMetricOptions[0].text
      if (current_selected_kpi_value === this.KPIMetricOptions[1].value){
        baseline_append_metric = this.KPIMetricOptions[1].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[2].value){
        baseline_append_metric = this.KPIMetricOptions[2].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[3].value){
        baseline_append_metric = this.KPIMetricOptions[3].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[4].value){
        baseline_append_metric = this.KPIMetricOptions[4].text;
      }
      console.log("Selected metric:",baseline_append_metric);
      //search logic here
      
      let series = [];
      if (this.result && this.result.length > 0) {
        for (let i = 0; i < this.baselines.length; i++) {
          let baseline = this.baselines[i];
          series.push({
            name: baseline.text.concat(" ",baseline_append_metric),
            data: this.getDatabyKPIMetric(baseline,current_selected_kpi_value)
          });
        }
      }
      if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
        this.setTotalSalesSeries(series);
      }
      else{
         this.series = series;
        this.setChartOptions();
        setTimeout(() => {
          this.hasData = true;
        }, 1000);
      }
      

    },
    getDatabyKPIMetric(baseline,current_selected_kpi_value) {
      console.log("Dynamic getdata invoked")
      let data = [];
      
      for (let x = 0; x < this.dates.length; x++) {
        let total_sales = 0;
        let d = this.dates[x];
        let filter_results = this.result.filter(
            obj => obj.baseline === baseline.value && obj.date === d
        );
        let sales = 0;
        if (filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[0].value) {
          sales = filter_results
              .map(item =>
                  item.sales_yoy_avg !== "NaN" ? parseFloat(item.sales_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[1].value) {
          sales = filter_results
              .map(item =>
                  item.traffic_yoy_avg !== "NaN" ? parseFloat(item.traffic_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[2].value) {
          sales = filter_results
              .map(item =>
                  item.average_check_yoy_avg !== "NaN" ? parseFloat(item.average_check_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[3].value) {
          sales = filter_results
              .map(item =>
                  item.frequency_yoy_avg !== "NaN" ? parseFloat(item.frequency_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[4].value) {
          sales = filter_results
              .map(item =>
                  item.recency_yoy_avg !== "NaN" ? parseFloat(item.recency_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        total_sales = total_sales + (sales*100);
        data.push({
          x: d,
          y: total_sales
        });
      }
      return data;
    },
    setChartOptions() {
      this.options = {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: true,
            tools: {
              download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
              customIcons: []
            }
          }
        },
        colors: [
          "#E91E63",
          "#2E93fA",
          "#FFFF00",
          "#66DA26",
          "#FF9800",
          "#546E7A"
        ],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        title: {
          text: `Campaign Started ${this.campaign_start} to ${this.campaign_end}`,
          align: "left"
        },
        xaxis: {
          type: "datetime",
          labels: {
              formatter: function (value, timestamp) {
                return moment(value).format('MMM-DD-YYYY')
              } 
          },
        },
        yaxis: {
          show: true,
          showAlways: true,
          labels: {
            show: false,
            formatter: function (val) {
              if (val === 0 || val === null) {
                return '0%';
              } else {
                return `${percentage_format(val)}`;
              }
            }

          }

        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
            show: true
          },
          marker: {
            show: true
          }
        },
        annotations: {
          xaxis: [
            {
              x: this.campaign_start,
              x2: this.campaign_end,
              fillColor: "#333333",
              label: {
                style: {
                  color: "#fff",
                  background: "#333333"
                },
                orientation: "horizontal",
                text: "Campaign Range"
              }
            }
          ]
        }
      };
    },
    displayMoneyFormatAmount(value) {
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));
      if (total_num < 0) {
        let x = total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return "-$" + Math.abs(x);
      }
      return "$" + total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    
  }
};
</script>

<template>
  <div>
    <v-card elevation="3" class="mt-10">
      <v-alert
          outlined
          type="info"
          text
          class="outer-container"
          v-if="hasMarketingRecommendations"
      >
        The below metrics are calculated against the performance of the local
        markets around the stores where you ran your campaign.
      </v-alert>
      <v-alert
          outlined
          type="info"
          text
          class="outer-container"
          v-if="!hasMarketingRecommendations"
      >
        No marketing recommendations are available for this campaign.
      </v-alert>

      <v-row class="mb-10" v-if="hasMarketingRecommendations">
        <v-col md="4">
          <v-card class="mx-auto" max-width="350" height="180">
            <v-card-title>
              SALES
            </v-card-title>
            <v-card-text>
              <div class="d-flex flex-column align-items-start mt-n3">
                <!-- <p class="text-h3 blue--text font-weight-bold">
                  {{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationTestValue
                    )
                  }}
                  
                </p> -->
                <p 
                v-if="increaseInSalesRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  +{{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}
                </p>
                <p 
                v-if="!increaseInSalesRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  -{{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold green--text"
                    v-if="increaseInSalesRecommendationIncreased"
                >
                  +{{ increaseInSalesRecommendationGrowth }}%
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold red--text"
                    v-if="!increaseInSalesRecommendationIncreased"
                >
                  -{{ increaseInSalesRecommendationGrowth }}%
                </p>
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="increaseInSalesRecommendationIncreased"
              >
                Your campaign increased sales by
                <span class="font-weight-bold green--text">
                  {{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}
                  or {{ increaseInSalesRecommendationGrowth }}%
                </span>
                compared to your local markets.
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="!increaseInSalesRecommendationIncreased"
              >
                Your campaign decreased sales by
                <span class="font-weight-bold red--text">
                  {{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}
                  or {{ increaseInSalesRecommendationGrowth }}%
                </span>
                compared to your local markets.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card class="mx-auto" max-width="350">
            <v-card-title>
              TRAFFIC
            </v-card-title>
            <v-card-text>
              <div class="d-flex align-items-center mt-n3">
                
                <p 
                v-if="trafficRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  +{{ formattedNewCustomersRecommendationDiff }}
                </p>
                <p 
                v-if="!trafficRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  -{{ formattedNewCustomersRecommendationDiff }}
                </p>
                
                <p
                    class="ml-2 text-h5 font-weight-bold green--text"
                    v-if="trafficRecommendationIncreased"
                >
                  +{{ formattedNewCustomersRecommendationGrowth }}%
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold red--text"
                    v-if="!trafficRecommendationIncreased"
                >
                  -{{ formattedNewCustomersRecommendationGrowth }}%
                </p>
              </div>
              <div class="text--primary mt-n2">
                Your campaign increased customers by
                <span v-if="isNetworkData" class="font-weight-bold green--text">
                N/A,
              </span>
              <span v-if="!isNetworkData" class="font-weight-bold green--text">
                {{ formattedNewCustomersRecommendationDiff }}
                or {{ formattedNewCustomersRecommendationGrowth }}%,
              </span>
                
                <span v-if="frequencyRecommendationIncreased">
                  increased frequency by
                  <span class="font-weight-bold green--text">{{
                      frequencyRecommendationTestValue
                    }}</span>
                  visits per month or
                  <span class="font-weight-bold green--text"
                  >{{ frequencyRecommendationGrowth }}%</span
                  >,
                </span>

                <span v-if="!frequencyRecommendationIncreased">
                  decreased frequency by
                  <span class="font-weight-bold red--text">{{
                      frequencyRecommendationTestValue
                    }}</span>
                  visits per month or
                  <span class="font-weight-bold red--text"
                  >{{ frequencyRecommendationGrowth }}%</span
                  >,
                </span>

                <span v-if="recencyRecommendationIncreased">
                  and increased recency by
                  <span class="font-weight-bold red--text">{{
                      recencyRecommendationTestValue
                    }}</span>
                  days or
                  <span class="font-weight-bold red--text"
                  >{{ recencyRecommendationGrowth }}%</span
                  >
                  compared to your local markets.
                </span>
                <span v-if="!recencyRecommendationIncreased">
                  and decreased recency by
                  <span class="font-weight-bold green--text">{{
                      recencyRecommendationTestValue
                    }}</span>
                  days or
                  <span class="font-weight-bold green--text"
                  >{{ recencyRecommendationGrowth }}%</span
                  >
                  compared to your local markets.
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card class="mx-auto" max-width="350" height="180">
            <v-card-title>
              AVERAGE CHECK
            </v-card-title>
            <v-card-text>
              <div class="d-flex align-items-center mt-n3">
                <!-- <p class="text-h3 blue--text font-weight-bold">
                  {{
                    displayMoneyFormatAmount(averageCheckRecommendationTestValue)
                  }}
                </p> -->
                <p
                    class="text-h3 blue--text font-weight-bold"
                    v-if="averageCheckRecommendationGrowthIncreased"
                >
                  +{{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                </p>
                <p
                    class="text-h3 blue--text font-weight-bold"
                    v-if="!averageCheckRecommendationGrowthIncreased"
                >
                  -{{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold green--text"
                    v-if="averageCheckRecommendationGrowthIncreased"
                >
                  +{{ displayMoneyFormatAmount(averageCheckRecommendationGrowth) }}%
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold red--text"
                    v-if="!averageCheckRecommendationGrowthIncreased"
                >
                  -{{ displayMoneyFormatAmount(averageCheckRecommendationGrowth) }}%
                </p>
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="averageCheckRecommendationGrowthIncreased"
              >
                Your campaign increased average check by
                <span class="font-weight-bold green--text">
                  {{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                  or {{ averageCheckRecommendationGrowth }}%</span
                >
                compared to your local markets.
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="!averageCheckRecommendationGrowthIncreased"
              >
                Your campaign decreased average check by
                <span class="font-weight-bold red--text"
                >{{
                    displayMoneyFormatAmount(averageCheckRecommendationDiff)
                  }}
                  or {{ averageCheckRecommendationGrowth }}%</span
                >
                compared to your local markets.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <!-- <v-alert outlined type="info" text class="outer-container" width="500">
      {{ yoyCategoryView }}
    </v-alert> -->
    <div class="card-separator" style="border-top: 2px solid #d4d9dd;margin: 30px 0;"></div>
    <v-card elevation="3" class="mt-10">
    <v-row  v-if="hasMarketingRecommendations" class="justify-space-between">
      <v-col >
        <v-alert outlined type="info" text class="outer-container" width="500">
          {{ yoyCategoryView }}
        </v-alert>
      </v-col>
      <v-col >
        <v-row class="justify-end">
          <div class="ml-3">
            <v-select
              v-model="formkpi.selectedKPIMetric"
              :items="KPIMetricOptions"
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"  
              width ="50"          
              :menu-props="{ top: false, offsetY: true }"
              return-object
              @change="handleKPIMetricChanges"
            >            
            </v-select>          
        </div>
        <div class="mr-3">
          <v-select
            v-model="formkpi.selectedYearOver"
            :items="overYearOption"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
            return-object
            @change="handleYearChanges"
          >
          </v-select>
        </div>
        </v-row>
      </v-col>
    </v-row>
    <apexchart
        :options="options"
        :series="series"
        type="area"
        height="300"
        :id="chartId"
    ></apexchart>
    </v-card>
  </div>
</template>